<template>
  <div class="labels-regenerate-container">
    <h3 class="labels-regenerate-title">REGENERATE LANGUAGE CACHE</h3>
    <div>
      Please make sure you reviewed your changes using the “Translation Tool”
      before clicking the “Regenerate cache” button to go live. <br />
      After doing so, we strongly recommend you review the changes again
      directly in the platform to be sure they are correct. <br />
      If you made a mistake please roll back using the RESTORE feature in the
      Backup - Restore Language section.
    </div>
    <b-button
      class="labels-regenerate-regenerate-button"
      variant="primary"
      @click="regenerateCache()"
    >
      REGENERATE CACHE
    </b-button>
    <div class="labels-regenerate-last-time">
      Last time you regenerated the language cache was on:
      <span v-if="lastRegeneration">{{
        lastRegeneration.cacheDate | formatDateWithTime
      }}</span>
      <span v-else>The regeneration hasn't taken place yet.</span>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import Icon from "vue-awesome/components/Icon";
import "vue-awesome/icons";
import "@/assets/icons/icons";
import { axiosCall } from "../../../../utils/axiosCall";

Vue.component("Icon", Icon);

export default {
  name: "LabelsRegenerateCache",
  data: function () {
    return {
      lastRegeneration: null,
    };
  },
  created: async function () {
    await this.getLastRegeneration();
  },
  methods: {
    getLastRegeneration: async function () {
      await axiosCall({ url: "LabelCache/LastRegeneration", method: "GET" })
        .then((response) => {
          this.lastRegeneration = response.data;
        })
        .catch(() => {});
    },
    regenerateCache: async function () {
      await axiosCall({
        url: "LabelCache/RegenerateCache",
        method: "GET",
      }).then(async () => {
        await this.getLastRegeneration();
      });
    },
  },
};
</script>
<style lang="scss">
.labels-regenerate {
  &-container {
    padding: 30px 60px;
  }
  &-title {
    margin-bottom: 30px;
  }
  &-regenerate-button {
    padding: 15px;
    margin-top: 30px;
    margin-bottom: 20px;
    border-radius: 5px !important;
  }
  &-last-time {
    font-size: 0.8rem;
    margin-top: 15px;
  }
}
</style>
